import createConfirm from './createConfirm';

export default createConfirm;


// WEBPACK FOOTER //
// ./frontend/cabinets/modules/shared/confirm/index.js